import React from 'react';
import DashboardView from 'dashboard/DashboardView.react';
import LoaderContainer from 'components/LoaderContainer/LoaderContainer.react';
import styles from './Settings.scss';
import Toolbar from 'components/Toolbar/Toolbar.react';
import EngineView from './EngineView.react';
import EngineViewOwner from './EngineViewOwner.react';


export default class Engine extends DashboardView {
  constructor() {
    super();
    this.section = 'Runtime';
    this.subsection = 'Engine';

    this.state = {
      loading: false,
      showFooter: false,
    };
  }

  onLoadComplete = () => {
    this.setState({ loading: true });
  }

  toggleFooter = (close) => {
    this.setState({
      showFooter: !close,
    });
  }

  renderContent() {
    const renderView = () => {
      if (this.props.isOwner && !this.context.currentApp.disable_engine_feature) {
        return (
          <EngineViewOwner
            currentCustomer={this.props.currentCustomer}
            currentApp={this.context.currentApp}
            appId={this.context.currentApp.id}
            onLoadComplete={this.onLoadComplete}
            toggleFooter={this.toggleFooter}
            showFooter={this.state.showFooter} />
        );
      }

      return (
        <EngineView
          currentCustomer={this.props.currentCustomer}
          currentApp={this.context.currentApp}
          appId={this.context.currentApp.id}
          onLoadComplete={this.onLoadComplete}
          toggleFooter={this.toggleFooter}
          showFooter={this.state.showFooter} />
      );
    };

    return (
      <div>
        <Toolbar section={this.section} subsection={this.subsection} />
        <div className={[styles.settings_page, this.state.showFooter ? styles.showFooter : ''].join(' ')}>
          <div className={styles.holder}>
            <LoaderContainer loading hideAnimation={this.state.loading} inner>
              {
                this.props.initialFields &&
                renderView()
              }
            </LoaderContainer>
          </div>
        </div>
      </div>
    );
  }
}
